import { z } from "zod";

export const SignedUrlPostBodySchema = z.object({
  filePath: z.string(),
});

export type SignedUrlPostBody = z.infer<typeof SignedUrlPostBodySchema>;
